import { lockr } from "@/core";
import { CACHED_TABS_ROUTES, TABS_WHITE_LIST } from "@/core/constant";
import { ITabsViewState } from "./state";
let setCachedFullPath = (route) => {
  route.cachedFullPath = getCachedFullPath(route);
};
let getCachedFullPath = (route) => {
  console.log("🚀 ~ file: mutations.ts:8 ~ getCachedFullPath ~ route:", route)
  if (route.matched) {
    return route.matched[route.matched?.length - 1]?.path;
  }
  return "";
};
export const mutations = {
  initTabs(state: ITabsViewState, routes) {
    state.tabsList = routes;
  },

  addTabs(state: ITabsViewState, route): boolean {
    if(window.top!=window.self){return true}// 如果是iframe中直接返回
    if (TABS_WHITE_LIST.includes(route.name)) return false;
    const oldRoute = state.tabsList.find((item) => item.cachedFullPath === route.cachedFullPath);
    // console.log("isExist", isExists, route.cachedFullPath);
    if (!oldRoute) {
      state.tabsList.push(route);
    }else{
      oldRoute.fullPath = route.fullPath;
    }
    lockr.set(CACHED_TABS_ROUTES, state.tabsList);
    return true;
  },

  // closeLeftTabs(state: ITabsViewState, route) {
  //   let cachedFullPath = getCachedFullPath(route);
  //   const index = state.tabsList.findIndex((item) => item.cachedFullPath === cachedFullPath);
  //   state.tabsList.splice(0, index);
  //   lockr.set(CACHED_TABS_ROUTES, state.tabsList);
  // },

  // closeRightTabs(state: ITabsViewState, route) {
  //   let cachedFullPath = getCachedFullPath(route);
  //   const index = state.tabsList.findIndex((item) => item.cachedFullPath === cachedFullPath);
  //   state.tabsList.splice(index + 1);
  //   lockr.set(CACHED_TABS_ROUTES, state.tabsList);
  // },

  closeOtherTabs(state: ITabsViewState, route) {
    // let cachedFullPath = getCachedFullPath(route);
    state.tabsList = state.tabsList.filter((item) =>
      ["/dashboard", route.cachedFullPath].includes(item.cachedFullPath)
    );
    lockr.set(CACHED_TABS_ROUTES, state.tabsList);
  },

  closeCurrentTab(state: ITabsViewState, route) {
    let cachedFullPath = route.cachedFullPath;
    const index = state.tabsList.findIndex((item) => item.cachedFullPath === cachedFullPath);
    state.tabsList.splice(index, 1);
    lockr.set(CACHED_TABS_ROUTES, state.tabsList);
  },

  closeAllTabs(state: ITabsViewState) {
    state.tabsList = [];
    lockr.set(CACHED_TABS_ROUTES, []);
  },
  setTablesMeta(state: ITabsViewState, route){
    let name = route.name;
    const index = state.tabsList.findIndex((item) => item.name === name);
    console.log(state.tabsList[index],'setTablesMetasetTablesMeta')
    state.tabsList[index] = route
    console.log(state.tabsList[index].meta,'setTablesMetasetTablesMeta')
    lockr.set(CACHED_TABS_ROUTES, state.tabsList);
  }

};
